export const DATAPOINT_ANALYTICS = {
  "DATAPOINT: Expanded Row": () => ({}),
};
